

















import BaseComponent from '@/components/base-component.vue';
import * as service from '@/services/address';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component
export default class UiCepTextField extends BaseComponent {
  @Prop()
  value: string;

  displayValue: string = null;

  loading = false;
  result = null;

  @Watch('value', { immediate: true })
  onValueChange(v) {
    this.displayValue = v;
  }

  onChange(v) {
    this.$emit('input', v);
  }

  buscarCep() {
    if (!this.displayValue) {
      return;
    }

    this.loading = true;
    service.findAddressByCep(this.displayValue).subscribe(
      (res) => {
        this.loading = false;
        this.result = res;
        this.$emit('result', res);
      },
      (error) => {
        this.loading = false;
        this.showToastApiError(error);
      }
    );
  }

  hasBtn() {
    return !this.$attrs['disabled'] && !this.$attrs['readonly'];
  }
}
